import React from "react";
import Loader from "./Loader";

interface TableListBranchesProps {
  columns: string[];
  data: any;
}

export const TableListBranches1: React.FC<TableListBranchesProps> = ({ columns, data }) => {
  if (!data || data.length === 0)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "50vh" }}
      >
        <Loader />
      </div>
    );

  const percentageValues: number[] = [];

  data?.forEach((row: any, rowIndex: number) => {
  Object.entries(row).forEach(([key, value]: [string, any]) => {
    if (typeof value === "string") {
      const trimmed = value.trim();

      if (!trimmed || ["--", "N/A", "null", "undefined"].includes(trimmed)) return;

      const normalized = trimmed.normalize();
      const cleanedValue = normalized.replace(/[^\d.-]/g, "");

      // Skip if cleanedValue is empty or not a valid numeric string
      if (!cleanedValue || !/^[-+]?\d*\.?\d+$/.test(cleanedValue)) return;

      const numericValue = parseFloat(cleanedValue);
      if (!isNaN(numericValue)) {
        percentageValues.push(numericValue);
      }
    }
  });
});


  const minPercentage = Math.min(...percentageValues);
  const maxPercentage = Math.max(...percentageValues);

  const getBackgroundColor = (value: string) => {
    const numericValue = parseFloat(value?.replace(/[%ML]/g, "").trim());
    if (isNaN(numericValue)) return "white";
    if (percentageValues.length === 1) return "#d15757";

    const opacity =
      minPercentage === maxPercentage
        ? 1
        : ((numericValue - minPercentage) / (maxPercentage - minPercentage)) * 0.8;

    return `rgba(255, 0, 0, ${opacity})`;
  };

  return (
    <div
      style={{
        margin: "20px",
        maxHeight: "60vh",
        overflow: "auto",
        border: "1px solid #dee2e6",
        borderRadius: "4px",
      }}
    >
      <table className="table" style={{ margin: "0", width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            {columns.map((col, index) => (
              <th
                key={index}
                className="tableHead"
                style={{
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#14213d",
                  color: "#fff",
                  minWidth: "100px",
                  fontSize: 12,
                  
                  textAlign: "center",
                  padding: "8px",
                  zIndex: 1,
                  fontWeight: "bold",
                }}
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody style={{ fontSize: 13, fontWeight: 400 }}>
          {data.map((row: any, rowIndex: number) => (
            <tr key={rowIndex}>
              {columns.map((col, colIndex) => (
                <td
                  key={colIndex}
                  className="border px-4 py-2"
                  style={{
                    background: getBackgroundColor(row[col]),
                    minWidth: "100px",
                    padding: "8px",
                    borderBottom: "1px solid #dee2e6",
                    
                  }}
                >
                  {row[col] || "-"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
